var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "under-cart__atomizer" };
var _hoisted_2 = { class: "btn__icon" };
import { ref } from 'vue';
import AtomizerModal from './AtomizerModal.vue';
import useCartApi from "../../api";
import Sprite from "../../../../components/Sprite.vue";
import { showPreloader } from "../../../../components/preloader";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Atomizers',
    setup: function (__props) {
        var atomizers = ref([]);
        var modal = ref();
        var api = useCartApi();
        function showModal() {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            showPreloader();
                            if (!!atomizers.value.length) return [3 /*break*/, 2];
                            return [4 /*yield*/, api.getAtomizers()];
                        case 1:
                            data = _b.sent();
                            if (data) {
                                atomizers.value = data;
                            }
                            _b.label = 2;
                        case 2:
                            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    onClick: showModal,
                    type: "button",
                    class: "btn btn--2 btn--m btn--black"
                }, [
                    _createElementVNode("span", _hoisted_2, [
                        _createVNode(Sprite, { name: "atomizer" })
                    ]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "btn__label" }, "Добавить атомайзер", -1 /* CACHED */))
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (_unref(atomizers).length)
                    ? (_openBlock(), _createBlock(AtomizerModal, {
                        key: 0,
                        ref_key: "modal",
                        ref: modal,
                        atomizers: _unref(atomizers)
                    }, null, 8 /* PROPS */, ["atomizers"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
